const REDIRECT_KEY = "beforeUrl";

const NOT_RESTORABLE_PATTERN = /^\/(login|sign-in|kakaologin|naverlogin|applelogin|success|program-booking-toss-pay)(\/|$|\?)/;

const normalize = (path: string) => {
    const slashed = path.replace(/\\/g, "/");
    try {
        return decodeURIComponent(slashed).toLowerCase();
    } catch {
        return null;
    }
};

const isRestorable = (path: string) => {
    const normalized = normalize(path);
    if (normalized === null) return false;
    if (!normalized.startsWith("/") || normalized.startsWith("//")) return false;
    return !NOT_RESTORABLE_PATTERN.test(normalized);
};

export const setUrl = (urlPath: string) => {
    if (!isRestorable(urlPath)) return;
    localStorage.setItem(REDIRECT_KEY, urlPath);
};
export const getUrl = () => {
    const stored = localStorage.getItem(REDIRECT_KEY);
    if (!stored || !isRestorable(stored)) return null;
    return stored;
};
export const removeUrl = () => {
    localStorage.removeItem(REDIRECT_KEY);
};
